/**
 * 学习证书
 */

import {
  post
} from '@/util/request'
import download from "@/util/download";
/**
 * 分页获取学习证书
 * @param {*} data
 * @returns
 */
export const GetDataCourseCertificateList = (data) => {
  return post('/api/app/user/getCertificateByAdmin', data, {});
}

/**
 * 批量删除学习证书
 * @param {*} data
 * @returns
 */
export const DeleteDataCourseCertificate = (data) => {
  return post('/api/app/user/batchDeleteCertificate', data, {});
}

/**
 * 审核学习证书
 * @param {*} data
 * @returns
 */
export const BatchAuditDataCourseCertificate = (data) => {
  return post('/api/app/user/batchAudit', data, {});
}

/**
 * 导出学习证书
 * @param {*} data
 * @returns
 */
export const ExportDataCourseCertificate = (data) => {
  let defaluturl = `/api/app/user/certificateExportExcelFile`;
  let fileName = "学习证书"
  return download(fileName, defaluturl, data);
}
